module.exports = __webpack_public_path__ + "static/img/tc06.09a52f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/tc06.png
// module id = 175
// module chunks = 0